import { useEffect, useState } from "react";
import { scrollToId, openWhatsApp } from "./shared";

const links = [
  { id: "storia", label: "La mia storia" },
  { id: "metodo", label: "Il metodo" },
  { id: "mentorship", label: "Mentorship" },
  { id: "contatto", label: "Scrivimi" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-[#080706]/90 backdrop-blur-xl border-b border-[#d4af37]/15" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-5 sm:px-10 h-16 sm:h-[70px]">
        <button
          data-testid="navbar-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3"
        >
          <span className="flex flex-col items-start leading-none">
            <span className="font-display text-base sm:text-lg tracking-[0.2em] gold-text font-bold">UOMO BIBLICO</span>
            <span className="text-[8px] sm:text-[9px] uppercase tracking-[0.28em] text-[#b8b2a7] mt-1">By Elio Briotti</span>
          </span>
        </button>
        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollToId(l.id)}
              className="text-[11px] uppercase tracking-[0.22em] text-[#b8b2a7] hover:text-[#f3e5ab] transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <button
          data-testid="nav-cta"
          onClick={openWhatsApp}
          className="cta-gold rounded-full px-5 sm:px-6 py-2.5 text-[10px] sm:text-[11px] uppercase"
        >
          Scrivimi su WhatsApp
        </button>
      </div>
    </header>
  );
};
